"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AlignToTop = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var AlignToTop = function AlignToTop() {
  return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M0 0.666667C0 0.298477 0.298477 0 0.666667 0H23.3333C23.7015 0 24 0.298477 24 0.666667V2C24 2.36819 23.7015 2.66667 23.3333 2.66667H17.3333V22.6667C17.3333 23.403 16.7364 24 16 24H8C7.26362 24 6.66667 23.403 6.66667 22.6667V2.66667H0.666667C0.298477 2.66667 0 2.36819 0 2V0.666667ZM9.33333 21.3333H14.6667V2.66667H9.33333V21.3333Z",
    clipRule: "evenodd"
  }));
};

exports.AlignToTop = AlignToTop;